import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import FooterEtapa from 'pages/FluxoProjetos/Components/footerEtapa/footerEtapa';
import TitleEtapa from 'pages/FluxoProjetos/Components/titleEtapa/titleEtapa';
import { useContext, useLayoutEffect } from 'react';
import DeOndePartimos from '../campos/deOndePartimos';
import styles from './etapas.scss';
const { rootClassName } = styles;

const etapa = EtapaProjeto.curriculo;
export default function Curriculo() {
  const { dispatch } = useContext(ProjetosContext);

  useLayoutEffect(() => {
    dispatch({ type: 'setEtapa', payload: etapa });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={rootClassName}>
      <TitleEtapa etapa={etapa} />
      <div className={`${rootClassName}-scrollable`}>
        <DeOndePartimos />
      </div>
      <FooterEtapa etapa={etapa} />
    </div>
  );
}
